module.exports = __webpack_public_path__ + "img/gas-icon.4fd37660.svg";